import React from 'react';
import gutter from './config/vars';
const diameter = window.innerWidth>899?"227px":"300px";
const SquareHead = (props) => (
  <div className='squareHeader' tabIndex="-1"
      style={{
        padding:gutter,
      height:props.size,
      width:props.size,
      backgroundRepeat: "no-repeat",
      backgroundImage:"url("+props.image+")",
      backgroundPositionX: props.nudgeX,
      backgroundPositionY:props.nudgeY,
      ...props.styles, 
    }}>
  </div>  

);
SquareHead.defaultProps = {
  styles:"",
  children: "No Image Provides",
  size:diameter, 
  nudgeX:"50%", 
  nudgeY:"50%", 
  image:"https://www.uvm.edu/content/sites/all/themes/uvm_admin/images/uvmlogo-lite.svg",
  

};
export default SquareHead;